import { render, staticRenderFns } from "./10.vue?vue&type=template&id=c45783a4&scoped=true&"
var script = {}
import style0 from "./10.vue?vue&type=style&index=0&id=c45783a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45783a4",
  null
  
)

export default component.exports